import api, { baseURL } from "../../../../utils/api"

export const getUser = async (page, limit , search) =>{
	const res = await api.get(`${baseURL}/user/allunsignedUsers?page=${page}&size=${limit}&search=${search}`);
    console.log("res" , res);
    return res
}